import { render, staticRenderFns } from "./Settings_Services.vue?vue&type=template&id=381c2049&scoped=true"
import script from "./Settings_Services.vue?vue&type=script&lang=js"
export * from "./Settings_Services.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381c2049",
  null
  
)

export default component.exports